'use client';
import { StyledBrandList } from '@/components/common/ygen/sections/brand-list/brandlist.style';
import React, { useMemo } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import reactHtmlParser from 'react-html-parser';
import Button from '@/components/common/ui/buttons/Button';
import LeftSVGScroll from '@/components/common/ui/buttons/LeftSVGScroll';
import RightSVGScroll from '@/components/common/ui/buttons/RightSVGScroll';
import { StyledPartnerProgress } from '@/components/common/ygen/sections/partner_progress/partner_porgress.style';
import Title from '@/components/common/ui/text/Title';

const PartnerProgress = ({ data }) => {
	// Memoize the posts list to prevent unnecessary re-renders
	const posts = useMemo(() =>
			data?.images?.list || [],
		[data?.images?.list]
	);


	// Memoize the renderBrandItem function to prevent unnecessary re-renders
	const renderBrandItem = useMemo(() =>
			(e, index) => {

				return (
					<Col md={4} key={index} className="single-image ">
						<div className="bg-light-subtle  d-flex align-items-center justify-content-center">
							<img src={e?.full_path} alt={e?.data?.title || 'Brand Image'} />
						</div>
					</Col>
				);
			},
		[],
	);

	return (
		<StyledPartnerProgress className="partner-progress" data-scroll-section>

			<Container>
				<Row>
					<Col md={12}>
						<Title
							tag="h2"
							textAlign={'center'}
							animClass="fade-up"
							margin="0 0 80px"
							text={'Partner in Progress'}
							color="#152637"
						/>
					</Col>
					{posts.length > 0 && posts.map((e, index) => renderBrandItem(e, index))}
				</Row>
			</Container>
		</StyledPartnerProgress>
	);
};


export default React.memo(PartnerProgress);